module.exports = __webpack_public_path__ + "assets/img/36_549.458fec4f.jpg";